export default "__VITE_ASSET__BNPt9xFr__"